module.exports = __webpack_public_path__ + "assets/img/amex@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/amex@2x.png
// module id = 126
// module chunks = 0